<template>
  <div class="timeline-header">
    <div class="timeline-header__title">
      <h3>
        {{ content.title }} <br />
        <span class="font-weight-light">{{ content.year }}</span>
      </h3>
    </div>

    <p class="timeline-header__instructions">
      {{ content.instruction }}
    </p>

    <list-legend-filter
      :legends="legends"
      :legend-title="'Filter category'"
      :value="selectCategory"
      :reset-label="'Reset to all categories'"
      @filter:legend="$emit('update:select-category', $event)"
    />

    <div class="timeline-header__controls">
      <!-- filter year -->
      <div class="row">
        <div class="col-6 col-xs-6 col-sm-6">
          <select-filter v-model="value.yearStart" :selections="startYears" fluid label="Select year" />
        </div>

        <div class="col-xs-6 col-6 col-sm-6">
          <select-filter v-model="value.yearEnd" :selections="endYears" fluid label="End year" />
        </div>
      </div>

      <!-- filter region -->
      <div class="row" style="padding-top: 0 !important">
        <div class="col-xs-6 col-6 col-sm-6">
          <select-filter v-model="value.region" :selections="regions" fluid label="Region" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListLegendFilter from '@/components/ui/ListLegendFilter.vue';
import SelectFilter from '@/components/ui/SelectFilter.vue';

export default {
  name: 'TimelineHeader',
  props: {
    content: {
      type: Object,
      required: true,
    },
    selectCategory: String,
    value: {
      type: Object,
      required: true,
    },
  },
  components: {
    ListLegendFilter,
    SelectFilter,
  },
  computed: {
    startYears() {
      return this.years.filter((item) => item <= this.value.yearEnd);
    },
    endYears() {
      return this.years.filter((item) => item >= this.value.yearStart);
    },
  },
  data() {
    return {
      selectedCategory: 'All',
      legends: [
        { name: 'Digital banking license', color: '#FDC4D0' },
        { name: 'FinTech conferences', color: '#A295E2' },
        { name: 'Funding and investments', color: '#005EB8' },
        { name: 'Industry news', color: '#F6C76A' },
        { name: 'Partnerships', color: '#E25A5F' },
      ],
      years: [2016, 2017, 2018, 2019, 2020],
      regions: [
        'All regions',
        'Asia',
        'Cambodia',
        'Indonesia',
        'Malaysia',
        'Myanmar',
        'Philippines',
        'Singapore',
        'Southeast Asia',
        'Thailand',
        'Vietnam',
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.timeline-header {
  margin-bottom: 30px;

  &__controls {
    .row:first-child {
      margin-bottom: 10px;
    }
  }
}
</style>
